enum ExternalLinks {
    CyfralServiceSite = `https://cyfral-group.ru/`,
    CyfralServiceSite_forOrganization = `http://business.cyfral-group.ru/`,
    CyfralServiceSite_offices = `https://cyfral-group.ru/all_towns`,
    Social_vk = `https://vk.com/cyfral_service`,
    Social_ok = `https://ok.ru/cyfral.service`,
    Social_yt = `https://www.youtube.com/@cyfral_service`,
    Social_tg = `https://t.me/cyfral_service`,
}

export default ExternalLinks